import { http } from "../http-common";
import { PageableResponse } from "../types/pagination";

export type SmsTestStatus = "DRAFT" | "SUCCESS" | "FAILED";

export interface ISmsTest {
  id: number;
  fullName: string;
  phoneNumber: string;
  message: string;
  status: SmsTestStatus;
  externalId?: string | null;
  lastSentAt?: string | null;
  lastErrorMessage?: string | null;
  createdAt?: string;
  updatedAt?: string;
}

export interface ISmsTestPayload {
  fullName: string;
  phoneNumber: string;
  message: string;
}

const list = (params?: any) => {
  const queryParams = {
    ...(params || {}),
    page: params?.page ?? 0,
    size: params?.size ?? 20,
  };

  return http.get<PageableResponse<ISmsTest>>("/sms-tests", {
    params: queryParams,
  });
};

const get = (id: number) => {
  return http.get<ISmsTest>(`/sms-tests/${id}`);
};

const create = (data: ISmsTestPayload) => {
  return http.post<ISmsTest>("/sms-tests", data);
};

const update = (id: number, data: ISmsTestPayload) => {
  return http.put<ISmsTest>(`/sms-tests/${id}`, data);
};

const remove = (id: number) => {
  return http.delete(`/sms-tests/${id}`);
};

const send = (id: number) => {
  return http.post<ISmsTest>(`/sms-tests/${id}/send`);
};

const SmsTestService = {
  list,
  get,
  create,
  update,
  remove,
  send,
};

export default SmsTestService;
